import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { ReportProvider } from '../reporting/ReportContext';
import { NvsLogo } from './NvsLogo';

export function PortalLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === 'admin';

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <ReportProvider>
      <div className="portal">
        <aside className="sidebar">
          <div className="sidebar-brand">
            <NvsLogo className="sidebar-logo" />
            <span className="sidebar-brand-text">
              <span className="sidebar-brand-name">NVS Logistics</span>
              <span className="sidebar-brand-sub">Reporting Portal</span>
            </span>
          </div>

          <nav className="sidebar-nav">
            <span className="sidebar-section">Reporting</span>
            <NavLink to="/reporting/overview">Overview</NavLink>
            <NavLink to="/reporting/failed">Failed deliveries</NavLink>
            <NavLink to="/reporting/difot">DIFOT</NavLink>
            <NavLink to="/reporting/driver-performance">Driver performance</NavLink>
            <NavLink to="/reporting/timing">Delivery timing</NavLink>
            <NavLink to="/reporting/milestone-location">Milestone location</NavLink>
            <NavLink to="/reporting/customer-feedback">Customer feedback</NavLink>
            <NavLink to="/reporting/dpd">DPD handoffs</NavLink>

            <span className="sidebar-section">Cost</span>
            <NavLink to="/cost/delivery">Delivery cost</NavLink>

            <span className="sidebar-section">Team</span>
            <NavLink to="/team/users">Users</NavLink>
            {isAdmin && <NavLink to="/invite">Invite user</NavLink>}
          </nav>

          <div className="sidebar-foot">
            <span className="sidebar-email">{user?.email}</span>
            <button type="button" onClick={handleSignOut}>Sign out</button>
          </div>
        </aside>

        <main className="portal-main">
          <Outlet />
        </main>
      </div>
    </ReportProvider>
  );
}
